import { Dispatch } from 'redux';
import { axiosV2 } from 'interceptors/axios';

import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';
import { ApiQueryParams } from 'types';

type getPartnerAvailableRangesProps = {
  partnerId: string;
  holdingClassId: string;
  params?: ApiQueryParams;
};

export const getPartnerAvailableRanges =
  ({ partnerId, holdingClassId, params }: getPartnerAvailableRangesProps) =>
  async (dispatch: Dispatch) => {
    const query = { params: { partnerId, holdingClassId, ...params } };

    try {
      const { data } = await axiosV2.get('/partners/availableRanges', query);

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
